"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var next_intl_1 = require("next-intl");
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var useGiftcodeBonus_1 = require("./useGiftcodeBonus");
var LoginGiftcodeBonus = function (_a) {
    var _b = _a.withText, withText = _b === void 0 ? false : _b;
    var t = (0, next_intl_1.useTranslations)('loginGiftcodeBonus');
    var _c = (0, useGiftcodeBonus_1.useGiftcodeBonus)(), bonus = _c.bonus, percent = _c.percent, amount = _c.amount, fs = _c.fs;
    if (!bonus)
        return null;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.wrapper },
        withText && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, t('title')),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.text }, t('text')))),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
            react_1.default.createElement("div", null, t('reward')),
            react_1.default.createElement("span", null, amount || fs || percent))));
};
exports.default = LoginGiftcodeBonus;
